export default class PostsLoadMore {
    constructor() {
        this.blogPage = document.querySelector('.blog');
        if (!this.blogPage)
            return;
        this.postsContainer = this.blogPage.querySelector('[data-posts]');
        this.loadTrigger = this.blogPage.querySelector('[data-load-trigger]');
        if (!this.loadTrigger)
            return;
        this.wordpressApiAction = '?action=elko_load_more_posts';
        this.getInfoData();
        this.addEventListeners();
    }
    getInfoData() {
        var _a, _b, _c, _d;
        const postsData = this.loadTrigger.getAttribute('data-load-trigger');
        const dataPairs = postsData.split(',').map(pair => pair.split(':'));
        const dataMap = {};
        dataPairs.forEach(([key, value]) => {
            dataMap[key.trim()] = parseInt(value.trim(), 10);
        });
        this.postsPerPage = (_a = dataMap['ppp']) !== null && _a !== void 0 ? _a : this.postsPerPage;
        this.page = (_b = dataMap['page']) !== null && _b !== void 0 ? _b : null;
        this.category = (_c = dataMap['cat']) !== null && _c !== void 0 ? _c : null;
        this.year = (_d = dataMap['year']) !== null && _d !== void 0 ? _d : null;
    }
    addEventListeners() {
        this.loadObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.getInfoData();
                    this.loadMorePosts();
                }
            });
        });
        if (!this.loadTrigger.classList.contains('hidden')) {
            this.loadObserver.observe(this.loadTrigger);
        }
    }
    loadMorePosts() {
        const formData = new FormData();
        formData.append('page', this.page.toString());
        formData.append('posts_per_page', this.postsPerPage.toString());
        formData.append('load_more', 'true');
        if (this.category)
            formData.append('category', this.category.toString());
        if (this.year)
            formData.append('year', this.year.toString());
        const options = {
            method: 'POST',
            body: formData
        };
        const ajaxURL = window.localize_script.admin_ajax + this.wordpressApiAction;
        fetch(ajaxURL, options)
            .then(response => response.json())
            .then(response => {
            if (response.success) {
                this.apiResults = response.data.html;
                if (!response.data.has_more) {
                    this.loadTrigger.classList.add('hidden');
                    this.loadObserver.unobserve(this.loadTrigger);
                }
                else {
                    this.loadTrigger.classList.remove('hidden');
                    this.loadObserver.observe(this.loadTrigger);
                }
                this.setInfoData();
                this.setDomElements();
                this.setUrlParams();
            }
            else {
                this.loadTrigger.classList.add('hidden');
                this.loadObserver.unobserve(this.loadTrigger);
            }
        })
            .catch(error => {
            console.error('Fetch error:', error);
        })
            .finally(() => {
            //
        });
    }
    setInfoData() {
        const postsData = this.loadTrigger.getAttribute('data-load-trigger');
        this.page++;
        const dataMap = {};
        postsData.split(',').forEach(pair => {
            const [key, val] = pair.split(':');
            dataMap[key.trim()] = val.trim();
        });
        dataMap['page'] = this.page.toString();
        const updatedPostsData = Object.entries(dataMap)
            .map(([key, val]) => `${key}:${val}`)
            .join(',');
        this.loadTrigger.setAttribute('data-load-trigger', updatedPostsData);
    }
    setUrlParams() {
        const url = new URL(window.location.href);
        let pathname = url.pathname.replace(/\/page\/\d+/, '').replace(/\/$/, '');
        const params = new URLSearchParams(url.search);
        if (this.page > 1) {
            pathname += `/page/${this.page}`;
        }
        const newUrl = `${pathname}${params.toString() ? '?' + params.toString() : ''}`;
        window.history.replaceState({}, '', newUrl);
    }
    setDomElements() {
        this.postsContainer.insertAdjacentHTML('beforeend', this.apiResults);
    }
}
